import { render, staticRenderFns } from "./LogoYoutubeIcon.vue?vue&type=template&id=08fa5fce&"
import script from "./LogoYoutubeIcon.vue?vue&type=script&lang=js&"
export * from "./LogoYoutubeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports